import { z } from 'zod';
/*
 * Verving (Nono-dugnaden) — contract for GET/POST /api/dashboard/referrals*.
 * Mirrors apps/api/src/referrals/index.ts listReferrals()/admin* shapes.
 */
export const referralStatusEnum = z.enum([
    'registrert',
    'booket',
    'medlem',
    'kvalifisert',
    'gitt',
    'diskvalifisert',
    'tilbakekalt',
]);
export const referralRow = z.object({
    id: z.number(),
    createdAt: z.string(),
    updatedAt: z.string(),
    channel: z.enum(['link', 'card', 'hint', 'staff']),
    refCode: z.string().nullable(),
    referrerName: z.string(),
    referrerPhone: z.string().nullable(),
    referrerMomenceId: z.string().nullable(),
    friendName: z.string().nullable(),
    friendPhone: z.string().nullable(),
    bookingRef: z.string().nullable(),
    friendMomenceId: z.string().nullable(),
    status: referralStatusEnum,
    statusLog: z
        .array(z.object({ status: z.string(), at: z.string(), note: z.string().optional() }))
        .nullable(),
    manuallyCreated: z.boolean(),
    householdFlag: z.boolean(),
    adOverlapFlag: z.boolean(),
    disqualifyReason: z.string().nullable(),
    rewardMonths: z.number(),
    rewardGivenAt: z.string().nullable(),
    rewardRevokedAt: z.string().nullable(),
    notes: z.string().nullable(),
});
export const referralsResponse = z.object({
    ok: z.literal(true),
    rows: z.array(referralRow),
    byStatus: z.record(z.string(), z.number()),
    leaderboard: z.array(z.object({
        name: z.string(),
        total: z.number(),
        kvalifisert: z.number(),
        gitt: z.number(),
    })),
    creditMonthsGiven: z.number(),
    creditMonthsCap: z.number(),
    rewardQueue: z.array(referralRow),
});
export const referralCreateBody = z.object({
    referrerName: z.string().min(2).max(120),
    referrerPhone: z.string().max(32).optional(),
    friendName: z.string().max(120).optional(),
    friendPhone: z.string().max(32).optional(),
    bookingRef: z.string().max(40).optional(),
    channel: z.enum(['staff', 'card']).default('staff'),
    notes: z.string().max(1000).optional(),
});
export const referralCreateResponse = z.object({ ok: z.literal(true), referral: referralRow });
export const referralStatusBody = z.object({
    status: referralStatusEnum,
    note: z.string().trim().min(8).max(500),
});
export const referralStatusResponse = z.object({ ok: z.literal(true), referral: referralRow });
//# sourceMappingURL=referrals.js.map